import React from 'react';

export const VolEventEarthquakeModal = {
  title: 'Earthquake',
  body: (
    <div>
      <p>
        A value of would indicate that there was a significant earthquake in conjunction with the volcanic eruption. The link connects to the event associated with the eruption in.
      </p>
    </div>
  ),
};
